// @flow
import * as React from 'react';
import { getAdQuestionUrl, getAuctioneerLogoUrl } from '../../utils/urls';
import ButtonLink from '@liveauctioneers/caterwaul-components/lib/ButtonLink/ButtonLink';
import { catalogCardDate } from '../../utils/dates';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import { safelyRender } from '../../utils/safelyRender';
import styles from './CatalogAd.module.scss';

type AdUnit = {
    destination: string,
    logoId: string,
    primaryImageUrl: string,
    saleStartTs: number,
    secondaryImageUrl: string,
    sellerName: string,
    tertiaryImageUrl: string,
    title: string,
};

type Props = {
    adUnit: AdUnit,
    className: string,
    trackClick: Function,
};

const CatalogAd = (props: Props) => {
    const { adUnit, className, trackClick } = props;
    const {
        destination,
        logoId,
        primaryImageUrl,
        secondaryImageUrl,
        saleStartTs,
        sellerName,
        title,
        tertiaryImageUrl,
    } = adUnit;

    const safeTitle = safelyRender(title, 'span');

    const routeProps: any = {
        to: destination,
    };

    if (!destination.startsWith('http')) {
        routeProps.route = true;
    }

    const classes = classNames(styles.catalogAd, className);

    return (
        <div className={styles.wrapper} onClick={trackClick}>
            <div className={classes}>
                <Link className={styles.logo} {...routeProps}>
                    {logoId && (
                        <ImageWithFallback
                            className={styles.image}
                            src={getAuctioneerLogoUrl(logoId, 162)}
                            alt={sellerName}
                        />
                    )}
                </Link>
                <Link className={styles['cover-lots']} {...routeProps}>
                    <div className={styles['cover']} style={{ backgroundImage: `url(${primaryImageUrl})` }} />
                    <div className={styles['cover']} style={{ backgroundImage: `url(${secondaryImageUrl})` }} />
                    <div className={styles['cover']} style={{ backgroundImage: `url(${tertiaryImageUrl})` }} />
                </Link>
                <Link className={styles.title} {...routeProps}>
                    {safeTitle}
                </Link>
                <span className={styles.date}>{catalogCardDate(saleStartTs)}</span>
                <ButtonLink small secondary url={destination} className={styles.explore}>
                    <FormattedMessage id="explore_auction" />
                </ButtonLink>
            </div>
            <div className={styles['your-ad-here']}>
                <FormattedMessage id="advertisement" />
                {'. '}
                <Link to={getAdQuestionUrl()}>
                    <FormattedMessage id="your_ad_here" />
                </Link>
            </div>
        </div>
    );
};

export default React.memo<Props>(CatalogAd, isEqual);
